module.exports = __webpack_public_path__ + "static/img/bannerBg3.82cf98f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg3.png
// module id = uQRQ
// module chunks = 1